<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <div class="control">
            <label class="label">Poll Name</label>
            <input class="input is-large" type="text" placeholder="Give this poll a name"
              v-model="poll.name"
            >
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <div class="control">
            <label class="label">Poll Slug</label>
            <input class="input is-large" type="text" placeholder="Poll Slug (Unique Identifier)"
              v-model="poll.slug"
            >
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <label class="label">Questions:</label>
        <draggable v-model="poll.questions">
          <transition-group>
            <poll-question v-for="(question, index) in poll.questions" :question="question"
             :index="index" :key="index" @delete-question="deleteQuestion(index)"
            ></poll-question>
          </transition-group>
        </draggable>
      </div>

      <div class="column">
        <label class="label">Preview:</label>
        <poll :data="poll"></poll>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <button class="button is-primary" @click="createNewQuestion">Another Question</button>
      </div>
      <div class="column has-text-right">
        <button class="button is-success" id="create" @click="savePoll" v-html="saveCopy"></button>
      </div>
    </div>

  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import slugify from 'slugify';
import PollQuestion from './PollQuestion.vue';
import Poll from './Poll.vue';
// import axios from 'axios'

export default {
  components: { Draggable, PollQuestion, Poll },
  props: ['url', 'edit_poll'],
  data() {
    return {
      newQuestionCopy: 'Create New Poll',
      newQuestionLoadingCopy: '<span class="voyager-refresh"></span> Saving New Poll',
      updateQuestionCopy: 'Update Question',
      saveCopy: '',
      post_url: '',
      poll: {
        id: '',
        name: '',
        slug: '',
        questions: [],
      },
    };
  },
  watch: {
    'poll.name': () => {
      this.poll.slug = slugify(this.poll.name).toLowerCase();
    },
  },
  methods: {
    newQuestion() {
      return {
        id: '',
        question: '',
        answers: [
          { id: '', answer: '' },
          { id: '', answer: '' },
          { id: '', answer: '' },
        ],
      };
    },
    createNewQuestion() {
      this.poll.questions.push(this.newQuestion());
    },
    savePoll() {
      // this.saveCopy = this.newQuestionLoadingCopy
      // var that = this
      // axios.post(this.post_url, { poll: this.poll })
      //     .then(function (response) {
      //         if(response.data.status == "success"){
      //             toastr.success(response.data.message)
      //             that.saveCopy = that.updateQuestionCopy
      //             that.newQuestionCopy = that.updateQuestionCopy
      //             that.post_url = that.url + '/admin/polls/edit'
      //             that.poll = response.data.poll
      //             history.replaceState(null, null, '/admin/polls/' + that.poll.id + '/edit')
      //         } else {
      //             toastr.error(response.data.message)
      //             that.saveCopy = that.newQuestionCopy
      //         }
      //       })
      //     .catch(function (error) {
      //         that.saveCopy = that.newQuestionCopy
      //         toastr.error(error.message)
      //     })
    },
    deleteQuestion(index) {
      this.poll.questions.splice(index, 1);
    },
  },
  created() {
    if (this.edit_poll) {
      this.poll = JSON.parse(this.edit_poll);
      this.newQuestionCopy = this.updateQuestionCopy;
      this.post_url = `${this.url}/admin/polls/edit`;
    } else {
      this.createNewQuestion();
      this.post_url = `${this.url}/admin/polls/add`;
    }
    this.saveCopy = this.newQuestionCopy;
  },
};
</script>

<style type="text/css">
  .btn-question {
    margin-top: 20px;
    display: block;
    width: auto;
    margin: 20px auto;
  }

  .voyager-refresh {
    -webkit-animation: spin 0.6s infinite linear;
    -moz-animation: spin 0.6s infinite linear;
    animation: spin 0.6s infinite linear;
    display: inline-block;
    width: 18px;
    height: auto;
    transform-origin: 8px 9px;
    position: relative;
    top: 2px;
  }

  .btn-question i {
    position: relative;
    top: 2px;
  }
</style>
